import { useMemo, useState } from "react";
import { combina } from "./CatalogoBusca";
import type { FichaResumo } from "./ServicoFichas";

type Servico = { id: string; label: string; active: boolean; originGlobalId?: string | null; origemNaBaseId?: string | null };

export const ehProprio = (s: Servico) => s.originGlobalId === null && !s.origemNaBaseId;

/**
 * Quais serviços a seção mostra: só os oferecidos (pedido do Jun). O que veio da base e foi
 * desligado volta pelo "Adicionar serviço", que reativa em vez de duplicar. Duas exceções:
 * - desmarcado agora continua à vista, desmarcado, até recarregar — o clique errado se desfaz ali;
 * - o criado pelo próprio laboratório não está na base, então os desligados ficam a um clique.
 */
export function useServicosAVista<T extends Servico>(todos: T[], busca: string, fichasPorServico: Map<string, FichaResumo[]>) {
  const [desmarcados, setDesmarcados] = useState<Set<string>>(new Set());
  const [verProprios, setVerProprios] = useState(false);

  const propriosDesligados = useMemo(() => todos.filter((s) => !s.active && ehProprio(s)).length, [todos]);
  const filtrados = useMemo(() => {
    const aVista = todos.filter((s) => s.active || desmarcados.has(s.id) || (verProprios && ehProprio(s)));
    if (!busca.trim()) return aVista;
    // A busca alcança o nome das fichas: procurar "BioCrown" acha o serviço que tem essa receita.
    return aVista.filter((s) => combina(s.label, busca) || (fichasPorServico.get(s.id) ?? []).some((f) => combina(f.name, busca)));
  }, [todos, busca, fichasPorServico, desmarcados, verProprios]);

  return {
    filtrados,
    temAtivo: todos.some((s) => s.active),
    propriosDesligados,
    verProprios,
    alternarProprios: () => setVerProprios((v) => !v),
    desmarcar: (ids: string[]) => setDesmarcados((prev) => new Set([...prev, ...ids])),
  };
}
